export enum EStatusEnvioCTeEvento {
  AguardandoEnvio = 0,
  EnviadaSemRetorno = 1,
  Finalizada = 2,
}

export const statusEnvioCTeEventoOptions = [
  { value: "0", label: "Aguardando Envio" },
  { value: "1", label: "Enviada Sem Retorno" },
  { value: "2", label: "Finalizada" },
];

export enum ETipoEventoCTe {
  Cancelamento = 110111,
  CartaCorrecao = 110110,
  PrestacaoServicoDesacordo = 610110,
  InsucessoEntrega = 110190,
}

export const tipoEventoCTeOptions = [
  { value: "110111", label: "110111 - Cancelamento" },
  { value: "110110", label: "110110 - Carta de Correção" },
];

export interface CTeEventoCancelamentoInputDto {
  justificativaCancelamento: string;
}

export interface CTeEventoCorrecaoInputDto {
  grupoAlterado: string;
  campoAlterado: string;
  valorAlterado: string;
  numeroItemAlterado?: number | null;
}

export interface CTeEventoCadastroDto {
  cTeId: number;
  tipoEvento: number;
  cancelamento?: CTeEventoCancelamentoInputDto | null;
  correcoes?: CTeEventoCorrecaoInputDto[] | null;
}

export interface CTeEventoCancelamentoDto {
  id: number;
  eventoId?: number;
  justificativaCancelamento: string;
}

export interface CTeEventoCorrecaoDto {
  id: number;
  grupoAlterado: string;
  campoAlterado: string;
  valorAlterado: string;
  numeroItemAlterado?: number | null;
}

export interface CTeEventoDto {
  id: number;
  cTeId: number;
  eventoDataHora: string;
  tipoEvento: number;
  tipoEventoDescricao: string;
  numeroSequencialEvento: number;
  versaoEvento: number;
  inclusaoUsuarioId: number;
  inclusaoDataHora: string;
  cancelamento?: CTeEventoCancelamentoDto | null;
  correcoes?: CTeEventoCorrecaoDto[] | null;
  codigoStatusResposta?: number | null;
  numeroProtocolo?: string | null;
  descricaoMotivoResposta: string;
  codigoStatusEnvio: EStatusEnvioCTeEvento;
  codigoStatusEnvioDescricao: string;
}

export interface CTeEventoFiltrarDto {
  id?: number;
  cTeId?: number;
  status?: number[];
}
